import './assets/form-checkbox-group.css';const o = {
  "form-input-control": "_form-input-control_1o27r_1",
  "form-input-control--with-device": "_form-input-control--with-device_1o27r_26",
  "form-input-control--is-flag": "_form-input-control--is-flag_1o27r_34",
  "form-input-control--is-bordered": "_form-input-control--is-bordered_1o27r_45",
  "form-input-control--is-label-full-width": "_form-input-control--is-label-full-width_1o27r_51",
  "form-input-control__description": "_form-input-control__description_1o27r_55",
  "form-input-control--is-selected": "_form-input-control--is-selected_1o27r_61",
  "form-input-control--is-square": "_form-input-control--is-square_1o27r_69",
  "form-input-control--size-sm": "_form-input-control--size-sm_1o27r_74",
  "form-input-control--is-invalid": "_form-input-control--is-invalid_1o27r_79",
  "form-input-control--is-disabled": "_form-input-control--is-disabled_1o27r_93",
  "form-input-control--with-label": "_form-input-control--with-label_1o27r_100",
  "form-input-control__signifier": "_form-input-control__signifier_1o27r_104",
  "form-input-control__control": "_form-input-control__control_1o27r_119",
  "form-input-control__icon": "_form-input-control__icon_1o27r_129",
  "form-input-control__label": "_form-input-control__label_1o27r_151",
  "form-input-control__label--with-signifier": "_form-input-control__label--with-signifier_1o27r_160",
  "form-input-control__description--with-media": "_form-input-control__description--with-media_1o27r_169",
  "form-input-control__label--with-media": "_form-input-control__label--with-media_1o27r_176",
  "form-input-control__text--with-media": "_form-input-control__text--with-media_1o27r_185",
  "form-input-control--with-media": "_form-input-control--with-media_1o27r_193",
  "form-input-control__media": "_form-input-control__media_1o27r_197",
  "form-input-control__label-container": "_form-input-control__label-container_1o27r_201",
  "form-multi-item": "_form-multi-item_1o27r_215",
  "form-multi-item--has-hidden-labels": "_form-multi-item--has-hidden-labels_1o27r_224",
  "form-multi-item__label": "_form-multi-item__label_1o27r_228",
  "form-multi-item__description": "_form-multi-item__description_1o27r_229",
  "form-multi-item--margin-bottom": "_form-multi-item--margin-bottom_1o27r_239",
  "form-multi-item__controls": "_form-multi-item__controls_1o27r_249",
  "form-multi-item__controls--inline": "_form-multi-item__controls--inline_1o27r_256",
  "form-multi-item__error": "_form-multi-item__error_1o27r_261",
  "form-multi-item__error-message": "_form-multi-item__error-message_1o27r_273",
  "form-multi-item__error-icon": "_form-multi-item__error-icon_1o27r_282",
  "form-multi-item__controls__separator": "_form-multi-item__controls__separator_1o27r_294",
  "form-multi-item__controls--inline-md-up": "_form-multi-item__controls--inline-md-up_1o27r_302"
};
export {
  o as s
};
